import { createApiReducer } from 'reacticoon/reducer'
import { fetchPublicVariablesList } from './actions'

const publicVariablesReducer = createApiReducer(fetchPublicVariablesList, {
  resetDataOnRequest: false,
})

export default publicVariablesReducer
